<template>
  <section class="form-contact-section nunito">
    <div class="content">
      <div class="top" v-if="!isContactPage">
        <h2 v-if="isHomePage">Ponerse en contacto</h2>
        <h1 v-else>Ponerse en contacto</h1>
        <p>Aquí encontraras nuestras vias de contactos, ubicación y redes sociales, tambien puedes dejarnos un mensaje o
          agendar tu cita.</p>
      </div>
      <OfficeHours marginB="100px" />

      <div class="container">
        <div class="left">
        </div>
        <div class="right">
          <form @submit.prevent="submitForm">
            <h3>Dejanos un mensaje</h3>
            
            <!-- Mensaje de éxito/error -->
            <div v-if="message" :class="['message', messageType]">
              {{ message }}
            </div>
            
            <div class="join">
              <label for="full-name-contact">
                <input 
                  type="text" 
                  name="full-name-contact" 
                  id="full-name-contact" 
                  v-model="formData.name"
                  minlength="5" 
                  required
                  placeholder=""
                  :disabled="loading">
                <span>Nombre completo</span>
              </label>
              <label for="company-contact">
                <input 
                  type="text" 
                  name="company-contact" 
                  id="company-contact" 
                  v-model="formData.company"
                  placeholder=""
                  :disabled="loading">
                <span>Empresa (opcional)</span>
              </label>
            </div>
            <div class="join">
              <label for="email-contact">
                <input 
                  type="email" 
                  name="email-contact" 
                  id="email-contact" 
                  v-model="formData.email"
                  required 
                  placeholder=""
                  :disabled="loading">
                <span>Correo electrónico</span>
              </label>
              <label for="phone-contact">
                <input 
                  type="tel" 
                  name="phone-contact" 
                  id="phone-contact" 
                  v-model="formData.phone"
                  required 
                  placeholder=""
                  :disabled="loading">
                <span>Teléfono</span>
              </label>
            </div>
            <div class="service-selection">
              <label for="service-contact">
                <select 
                  name="service-contact" 
                  id="service-contact" 
                  v-model="formData.service"
                  required
                  :disabled="loading">
                  <option value="">Selecciona un servicio</option>
                  <option value="SEO">SEO y Optimización Web</option>
                  <option value="Redes Sociales">Gestión de Redes Sociales</option>
                  <option value="Publicidad Digital">Publicidad Digital</option>
                  <option value="Marketing Digital">Estrategia de Marketing Digital</option>
                  <option value="Otro">Otro servicio</option>
                </select>
              </label>
            </div>
            <label for="message-contact">
              <textarea 
                name="message-contact" 
                id="message-contact" 
                v-model="formData.message"
                minlength="10" 
                required 
                placeholder=""
                :disabled="loading"></textarea>
              <span>Mensaje</span>
            </label>
            <button 
              type="submit" 
              title="Enviar mensaje"
              :disabled="loading">
              <i v-if="!loading" class="fa-regular fa-paper-plane"></i>
              <i v-else class="fa-solid fa-spinner fa-spin"></i>
              <span>{{ loading ? 'Enviando...' : 'Enviar mensaje' }}</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import OfficeHours from '../components/OfficeHours-component.vue'
import apiService from '../config/api.js'

export default {
  name: 'FormContactComponent',
  components: {
    OfficeHours
  },
  data() {
    return {
      isHomePage: false,
      isContactPage: false,
      loading: false,
      message: '',
      messageType: 'success',
      formData: {
        name: '',
        email: '',
        phone: '',
        company: '',
        service: '',
        message: ''
      }
    };
  },
  created() {
    if (this.$route.path === '/') {
      this.isHomePage = true;
    }
    if (this.$route.path === '/contact') {
      this.isContactPage = true;
    }
  },
  mounted() {
    const inputs = this.$el.querySelectorAll('input, textarea, select');

    inputs.forEach(input => {
      input.addEventListener('focus', () => {
        input.classList.add('filled');
      });

      input.addEventListener('blur', () => {
        if (input.value.trim() === '') {
          input.classList.remove('filled');
        } else {
          input.classList.add('filled');
        }
      });

      // Para selects, manejar el evento change
      if (input.tagName === 'SELECT') {
        input.addEventListener('change', () => {
          if (input.value.trim() === '' || input.value === '') {
            input.classList.remove('filled');
          } else {
            input.classList.add('filled');
          }
        });
        
        // Verificar estado inicial del select
        if (input.value && input.value !== '') {
          input.classList.add('filled');
        }
      }

      // Check on load
      if (input.value.trim() !== '') {
        input.classList.add('filled');
      }
    });
  },
  watch: {
    'formData.service'(newValue) {
      const select = this.$el.querySelector('#service-contact');
      if (select) {
        if (newValue && newValue !== '') {
          select.classList.add('filled');
        } else {
          select.classList.remove('filled');
        }
      }
    }
  },
  methods: {
    async submitForm() {
      this.loading = true;
      this.message = '';
      
      try {
        const response = await apiService.submitContact(this.formData);
        
        if (response.success) {
          this.message = response.message;
          this.messageType = 'success';
          this.resetForm();
        } else {
          this.message = response.error || 'Error al enviar el mensaje';
          this.messageType = 'error';
        }
      } catch (error) {
        console.error('Error submitting contact form:', error);
        this.message = 'Error de conexión. Intenta nuevamente.';
        this.messageType = 'error';
      } finally {
        this.loading = false;
      }
    },
    
    resetForm() {
      this.formData = {
        name: '',
        email: '',
        phone: '',
        company: '',
        service: '',
        message: ''
      };
      
      // Reset form classes
      const inputs = this.$el.querySelectorAll('input, textarea, select');
      inputs.forEach(input => {
        input.classList.remove('filled');
      });
      
      // Forzar la actualización del DOM para el select
      this.$nextTick(() => {
        const select = this.$el.querySelector('select');
        if (select) {
          select.classList.remove('filled');
        }
      });
    }
  }
}
</script>


<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

.message {
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-weight: 500;
  
  &.success {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
  }
  
  &.error {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
  }
}

.service-selection {
  width: 100%;
  margin-bottom: 20px;
  
  label {
    position: relative;
    display: block;
    
    select {
      width: 100%;
      padding: 12px 16px;
      border: 2px solid #e1e5e9;
      border-radius: 8px;
      font-size: 16px;
      background-color: white;
      transition: all 0.3s ease;
      
      &:focus {
        outline: none;
        border-color: #1f8cc6;
        box-shadow: 0 0 0 3px rgba(31, 140, 198, 0.1);
      }
      
      &:disabled {
        background-color: #f8f9fa;
        cursor: not-allowed;
      }
    }
    
    span {
      position: absolute;
      top: 12px;
      left: 16px;
      color: #6c757d;
      transition: all 0.3s ease;
      pointer-events: none;
      font-size: 16px;
    }
    
    select:focus + span,
    select.filled + span,
    select:not([value=""]) + span {
      top: -8px;
      left: 12px;
      font-size: 12px;
      color: #1f8cc6;
      background-color: white;
      padding: 0 4px;
    }
  }
}

button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

body.dark-theme .form-contact-section {

  &::before {
    background: linear-gradient(to top, #131415, #131415);
  }

  .content {

    .top {

      h1,
      h2 {
        color: white;
      }

      p {
        color: #ccc;
      }
    }

    .container {
      background: #1f2122;

      .right {
        form {
          h3 {
            color: white;
          }

          button {
            background: #e8505b;
          }

          label {
            color: #ccc;

            input,
            textarea {
              border: 1px solid #302f2f;
              background: #303134;
              transition: background 0.4s;
              color: white;

              &:focus+span,
              &.filled+span {
                color: #e8eaed;
                font-weight: normal;
              }


            }
          }
        }
      }
    }
  }
}


.form-contact-section {
  width: 100%;
  position: relative;

  .content {
    width: 100%;
    max-width: 1480px;
    margin: 0 auto;

    .top {
      text-align: center;
      max-width: 700px;
      width: 100%;
      padding: 0 20px;
      margin: 0 auto;
      margin-bottom: 40px;

      h1,
      h2 {
        font-size: 2rem;
      }

      p {
        font-size: 20px;
        color: #5a5a5a;
      }
    }


    .container {
      width: 80%;
      margin: 50px auto;
      border-radius: 30px;
      background: #f6f6f6;
      padding: 20px;
      // background: white;
      display: flex;
      justify-content: space-around;
      gap: 30px;

      @media (max-width: 1000px) {
        flex-wrap: wrap;
        width: 70%;
      }

      @media (max-width: $breakpoint-md) {
        width: 90%;

      }

      @media (max-width: $breakpoint-sm) {
        padding: 30px 20px;
        border-radius: 40px;

        width: 100%;
      }

      .left {
        max-width: 50%;
        width: 100%;
        min-width: 300px;
        border-radius: 20px;
        overflow: hidden;

        iframe {
          width: 100% !important;
          border: 0;
          outline: none;
          border-radius: 30px !important;
          height: 100% !important;
        }

        @media (max-width: 1000px) {
          width: 100%;
          max-width: 100%;
          height: 300px;
        }
      }

      .right {
        flex: 1;
        padding: 25px 20px;

        @media (max-width: 1000px) {
          padding: 10px 0px;
        }

        form {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          gap: 20px 0;

          .join {
            width: 100%;
            display: flex;
            align-items: center;
            gap: 10px;
          }

          label {
            width: 100%;
            position: relative;
            display: flex;
            flex-direction: column-reverse;

            span {
              position: absolute;
              top: 13px;
              left: 10px;
              font-size: 16px;
              color: #999;
              transition: all 0.2s;
              pointer-events: none;
            }

            textarea {
              min-height: 200px !important;
              max-height: 200px;
            }



            input,
            textarea {
              width: 100%;
              padding: 15px 10px;
              border: 1px solid #ccc;
              border-radius: 4px;
              outline: none;

              &:focus+span {
                top: 0px;
                font-size: 12px;
                color: #030910;
                font-weight: 700;
              }

              &.filled+span {
                top: 0px;
                font-size: 12px;
                color: #030910;
                font-weight: 700;
              }
            }

            textarea {
              min-height: 100px;
              resize: vertical;
            }
          }

          button {
            background: #e8505b;
            padding: 20px 20px;
            border: none;
            border-radius: 5px;
            color: white;
            display: flex;
            gap: 10px;
            cursor: pointer;
            transition: background 0.3s;

            span {
              display: inline-flex;
            }

            &:hover {
              transition: background 0.3s;
              background: #eda305;
            }
          }
        }
      }


    }
  }
}
</style>